import React from 'react';
import { Grid, InputLabel, MenuItem, OutlinedInput, Select } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import OfficialDiaryDataTable from './components/official-diary-data-table';
import DefaultSelectClient from '../../../components/default-select-client';
import PageHeader from '../../../components/page-header';
import { FilterPanel } from '../../../components/filter-panel';
import { GridPanel } from '../../../components/list-grid-panel';
import { DateField } from '../../../components/form-page-parts';
import { useOfficialDiarySearchController } from './context/official-diary-search-controller';
import { useOfficialDiarySearchState } from './context/official-diary-search-context';

export function OfficialDiarySearchComponent() {
    const ctrl = useOfficialDiarySearchController();
    const { parameters } = useOfficialDiarySearchState();

    const searchOnEnter = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') ctrl.handleSearch();
    };

    return (
        <React.Fragment>
            <Grid item xs={12}>
                <PageHeader
                    title="Diário Oficial"
                    subtitle="Consulte e gerencie as edições do Diário Oficial"
                    breadcrumbs={[{ label: 'Diário Oficial' }]}
                />
            </Grid>

            <Grid item xs={12}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <FilterPanel onClear={ctrl.handleClearFilters} onSearch={ctrl.handleSearch}>
                        <Grid item xs={6} sm={4} md={2}>
                            <InputLabel>Nº edição</InputLabel>
                            <OutlinedInput name="input-number" fullWidth type="number" inputProps={{ min: 0 }} value={parameters.number ?? ''} onChange={ctrl.handleOnChange} onKeyDown={searchOnEnter} />
                        </Grid>
                        <Grid item xs={6} sm={4} md={2}>
                            <InputLabel>Ano</InputLabel>
                            <OutlinedInput name="input-year" fullWidth type="number" inputProps={{ min: 0 }} value={parameters.year ?? ''} onChange={ctrl.handleOnChange} onKeyDown={searchOnEnter} />
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <InputLabel>Situação</InputLabel>
                            <Select
                                fullWidth
                                displayEmpty
                                name="select-closed"
                                value={parameters.isClosed === undefined ? '' : String(parameters.isClosed)}
                                onChange={ctrl.handleOnChange}
                            >
                                <MenuItem value=""><em>Todos</em></MenuItem>
                                <MenuItem value="true">Fechada</MenuItem>
                                <MenuItem value="false">Aberta</MenuItem>
                            </Select>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <DateField label="Data da edição inicial" value={parameters.startDate} maxDate={dayjs()} onChange={ctrl.handleStartDateChange} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <DateField label="Data da edição final" value={parameters.endDate} maxDate={dayjs()} onChange={ctrl.handleEndDateChange} />
                        </Grid>
                        <Grid item xs={12}>
                            <DefaultSelectClient required={false} clientId={parameters.clientId} handleOnChange={ctrl.handleOnChange} />
                        </Grid>
                    </FilterPanel>
                </LocalizationProvider>
            </Grid>

            <Grid item xs={12}>
                <GridPanel addLabel="Nova publicação" onAdd={ctrl.navigateToCreate}>
                    <OfficialDiaryDataTable
                        rows={ctrl.list.rows}
                        rowCount={ctrl.list.rowCount}
                        loading={ctrl.list.loading}
                        page={parameters.page ?? 0}
                        pageSize={parameters.pageSize ?? 25}
                        onPaginationChange={ctrl.handlePaginationChange}
                        onDetail={ctrl.navigateToDetail}
                        onChangeVisibility={ctrl.handleChangeVisibility}
                        onCloseEdition={ctrl.handleCloseEdition}
                    />
                </GridPanel>
            </Grid>
        </React.Fragment>
    );
}
